import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {  computed, PropType, ref, toRef, watch } from "vue"
import { TipTapEditor, markdownToEditorHtml, editorHtmlToMarkdown } from "hjelseth-richeditor"
import "hjelseth-richeditor/dist/hjelseth-richeditor.css"

type EditorExtensionsConfig = {
  image?: boolean
  codeBlock?: boolean
  table?: boolean
  mention?: boolean
  toc?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MarkdownEditor',
  props: {
  modelValue: { type: String, required: true },
  mediable: { type: Object as PropType<{ id: string | number; type: string }> },
  editorOptions: { type: Object, required: false },
  withMentions: { type: Boolean, default: false },
  mentionable: { type: Object as PropType<any> },
  attachmentEndpoint: { type: String, required: true },
    extensions: {
    type: Object as PropType<EditorExtensionsConfig>,
    required: false,
  },
},
  emits: ["update:modelValue", "uploadingImages", "getMentions"],
  setup(__props, { emit }) {

const props = __props;





const modelValue = toRef(props, "modelValue")
const html = ref<string | null>(markdownToEditorHtml(modelValue.value || ""))
const editorMarkdown = ref<string | null>(modelValue.value || null)

const extensions = computed<EditorExtensionsConfig>(() => props.extensions || {})

watch(modelValue, (nv) => {
  if (editorMarkdown.value !== nv) html.value = markdownToEditorHtml(nv || "")
})
watch(html, (nv) => {
  const md = editorHtmlToMarkdown(nv || "")
  editorMarkdown.value = md
  emit("update:modelValue", md)
})

return (_ctx: any,_cache: any) => {
  return (html.value !== null)
    ? (_openBlock(), _createBlock(_unref(TipTapEditor), {
        key: 0,
        modelValue: html.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((html).value = $event)),
        editorOptions: __props.editorOptions,
        mediable: __props.mediable,
        withMentions: __props.withMentions,
        mentionable: __props.mentionable,
        attachmentEndpoint: __props.attachmentEndpoint,
        onUploadingImages: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('uploadingImages', $event))),
        onGetMentions: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('getMentions', $event))),
        extensions: extensions.value
      }, null, 8, ["modelValue", "editorOptions", "mediable", "withMentions", "mentionable", "attachmentEndpoint", "extensions"]))
    : _createCommentVNode("", true)
}
}

})